import { render, staticRenderFns } from "./AboutGift.vue.html?vue&type=template&id=5158da74&scoped=true&"
import script from "./AboutGift.component.js?vue&type=script&lang=vueJs&"
export * from "./AboutGift.component.js?vue&type=script&lang=vueJs&"
import style0 from "./AboutGift.scoped.scss?vue&type=style&index=0&id=5158da74&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5158da74",
  null
  
)

export default component.exports